import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { API_ENDPOINT, BaseHttpService, ENDPOINTS } from './base-http.service';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root',
})
export class ExecutionService extends BaseHttpService {
    constructor(
        private _http: HttpClient,
        protected _tokenService: TokenService
    ) {
        super(_tokenService);
    }

    // TODO: add the returned type to be a specific object
    saveExecution(data: FormData): Observable<any> {
        return this._http.post(
            `${API_ENDPOINT}/${ENDPOINTS.EXECUTION}/`,
            data,
            this.authorizedRequestOptions
        );
    }

    // TODO: add the returned type to be a specific object
    getHistory(): Observable<any> {
        return this._http.get(
            `${API_ENDPOINT}/${ENDPOINTS.EXECUTION}/`,
            this.authorizedRequestOptions
        );
    }

    // TODO: add the returned type to be a specific object
    deleteExecution(executionId: number): Observable<any> {
        return this._http.delete(
            `${API_ENDPOINT}/${ENDPOINTS.EXECUTION}/${executionId}/`,
            this.authorizedRequestOptions
        );
    }

    getExecutionSample(fileUrl: string): Observable<Blob> {
        fileUrl = fileUrl.replace(
            'http://backend/',
            `${environment.BACKEND_URL}/`
        );
        return this._http.get(fileUrl, {
            ...this.authorizedRequestOptions,
            responseType: 'blob',
        });
    }
}
